<template>
  <div class="lifecommen">
  
    <div class="commenlive">
        <div  class="zhanwei" v-show="lifeProgram[0] == 'none'"  >
        <!-- <img src="../../assets/noprogram@2x.png" alt=""> -->
       </div>
      <div class="live" v-show="lifeProgram[0] != 'none'"  v-for="(item,index) in lifeProgram" :key="index">
       
          <div class="img"  @click="toDownloadpage">
               <img :src="item.image" alt="" class="lifeImg">
               <img v-show="item.liveSourceType=='4'" src="../../assets/audio@2x.png" alt="" class="liveSourceType">
               <img v-show="item.liveSourceType=='0'" src="../../assets/video@2x.png" alt="" class="liveSourceType">
               <div class="show-number">
               
                 <p class="show_spectators">
                    <img  src="../../assets/live@2x.png" alt="" class="liveImg">
                     <font>{{item.show_spectators}}</font>
                 </p>
                   <p class="beforeTime"> 
                   {{item.time}}
                     <!-- {{item.time |diffTime}} -->
                 </p>
               </div>
          </div>
         <figcaption>
            <p class="liveName">
              {{item.title}}
              </p>
            <p class="liveCaption">
              {{item.label}}
              </p>
        
            
         </figcaption>
      </div> 

    </div>
   
  </div>
</template>

<script>
// let baseurl="http://api.dev.cbct.cn/"
import  {formatDate} from '../../../static/js/date.js'

export default {
  name: 'programcommen',
  props: ["lifeProgram"],
  data(){
    return { 
     commenLifeData:'',
    }
  },
  filters:{
   diffTime:function(d1){
    //  console.log("d1",d1)
     var dateBegin = d1*1000;
    //  console.log("dateBegin",dateBegin)
     var dateEnd = new Date();//获取当前时间
    //  var dateDiff = dateEnd.getTime() - dateBegin.getTime();//时间差的毫秒数

    var strData = "";
    var dateDiff  = dateEnd.getTime() - dateBegin;//时间差的毫秒数
    // console.log("dateDiff",dateDiff);
     var second=Math.round(dateDiff/1000);
     var minute=Math.round(dateDiff/1000/60);
     var hour=Math.round(dateDiff/1000/60/60)
     var day=Math.round(dateDiff/1000/60/60/24)
     var month=Math.round(dateDiff/1000/60/60/24/30)
    if (second>=0&&second<60) {
       strData = "刚刚";
    }else if(minute>0&&minute<60){
        strData = minute +"分钟前";
    }
    else if(hour>0&&hour<24){
        strData = hour + "小时前";
    }else if(day > 0 && day < 30){
                strData = day + "天前";
    } else if(month > 0 && month <= 6){
                strData = month + "个月前";
     }else{
        strData=formatDate(dateBegin,'yyyy-MM-dd');
     }
     
    return strData;
   },
  //  formatDate(time) {
  //     // time=time.replace("");
  //     var date = new Date(time*1000);
  //     return formatDate(date, 'yyyy-MM-dd');
  //   }

  },
  methods:{
    toDownloadpage(){
      this.$router.push({path:"downloadApp?isFrom=programRecorded"});
    }
  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.lifecommen{
  width: 100%;
  box-sizing: border-box;
  overflow: hidden;
  padding: 0 0.24rem;
  /* border: solid 1px; */
  
} 
.commenlive{
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  margin-bottom: 1rem;
}
.commenlive .live{
  width: 3.42rem;
}
.live .img{
  width: 100%;
  height: 3.42rem;
  position: relative;
  /* background: darkgoldenrod; */
  margin: 0;
}
.live .img .lifeImg{
  width: 100%;
  height: 100%;
  border-radius: 0.2rem;
}
.live .img .liveSourceType{
  position: absolute;
  margin: auto;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  width: 0.88rem;
  height: 0.88rem;
}
.show-number{
   position: absolute;
   /* border: solid 1px; */
   height: 0.96rem;
   box-sizing: border-box;
   width: 100%;
   bottom: 0rem;
   padding: 0.6rem 0.25rem 0.16rem;
   font-size:0.21rem;
   /* font-family:PingFang-SC-Bold;
   font-weight:bold; */
   color:rgba(255,255,255,1);
   display: flex;
   justify-content: space-between;

}
.liveImg{
  width:0.14rem;
  height:0.18rem;
  margin-right: 0.12rem;
}
.liveImg1{
  width:0.3rem;
  height:0.3rem;
  margin-right: 0.12rem;
}

.live figcaption{
  box-sizing: border-box;
  width: 100%;
  display: inline-block;
  padding: 0rem 0rem 0rem 0.04rem;
  text-align: left;
}

.liveName{
  font-size:0.3rem;
  color:rgba(102,102,102,1);
  width: 100%;
  white-space:nowrap;
  overflow:hidden;
  padding-top: 0.24rem;
  padding-bottom: 0.1rem;
  text-overflow:ellipsis;
  font-weight:500;
  height: 0.288rem;
}
.liveCaption{
  padding: 0.07rem 0 0.3rem;
  height: 0.24rem;
  font-size:0.24rem;
  color:rgba(153,153,153,1);
  width: 100%;
  white-space:nowrap;
  overflow:hidden;
  text-overflow:ellipsis;
}
.zhanwei{
  width:3.24rem;
  margin:0 auto;
  height: 2.6rem;
  margin-top:1rem;
  background: url('../../assets/noprogram@2x.png');
  background-size:100%;
}
.zhanwei img{
  width:3.24rem;
}

</style>
